export default {
  placeholder: 'Cerca marchio...',
};
